import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
export class SelectablePdfDataFilter extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], SelectablePdfDataFilter.prototype, "id", void 0);
export class SelectablePdfSheetFilter extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.items = [];
    }
}
__decorate([
    field({ decoder: StringDecoder })
], SelectablePdfSheetFilter.prototype, "id", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(SelectablePdfDataFilter) })
], SelectablePdfSheetFilter.prototype, "items", void 0);
export class SelectablePdfDocumentFilter extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.sheets = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(SelectablePdfSheetFilter) })
], SelectablePdfDocumentFilter.prototype, "sheets", void 0);
//# sourceMappingURL=SelectablePdfDocumentFilter.js.map